export const INVALID_EMAIL_MESSAGE = "Indirizzo email non valido.";
export const EMAIL_REQUIRED = "L'e-mail è obbligatoria.";
export const PASSWORD_REQUIRED = "È richiesta la password.";
export const PASSWORD_LENGTH_MESSAGE = "La password deve contenere almeno 8 caratteri.";
export const SOME_WENT_WRONG  = "Qualcosa è andato storto.";
export const FORGET_PASSWORD_TITLE = "Inserisci la tua email per reimpostare la password.";
export const FORGET_PASSWORD_LINK_MESSAGE  = "Un link per il reset è stato inviato alla tua email. Controlla la tua casella di posta.";
export const EMAIL_INVALID_FORMAT = "Formato email non valido.";
export const INVALID_CHANGE_PASSWORD_LINK = "Il link fornito non è corretto.";
export const SHOP_ADDRESS_REQUIRED = "È obbligatorio specificare l'indirizzo del negozio.";
export const LOGIN_SUCCESS  = "Accesso effettuato con successo.";
export const ACCOUNT_VERIFY_LINK = "Un'email di verifica dell'account è stata inviata con il link.";
export const INVALID_VERIFICATION_LINK = "Il link di verifica dell'account fornito non è corretto.";
export const VERIFICATION_SUCCESS = "Il tuo account è stato verificato con successo.";
export const COMPANY_NAME_REQUIRED = "È obbligatorio il Rag. Sociale.";
export const ZIP_CODE_REQUIRED = "Il CAP è obbligatorio.";
export const COUNTRY_REQUIRED = "Il codice paese è obbligatorio.";
export const CITY_REQUIRED = "La città è obbligatoria.";
export const PROVINCE_CODE_REQUIRED = "Il codice provincia è obbligatorio.";
export const PHONE_NUMBER_REQUIRED = "Il numero di telefono è obbligatorio.";
export const VAT_REQUIRED = "È richiesta l'IVA.";
export const ACCOUNT_MARGIN_REQUIRED = "Il margine previsto dell'account è obbligatorio.";
export const ACCOUNT_MARGIN_NUMBER = "Il margine previsto dell'account deve essere un numero.";
export const ACCOUNT_MARGIN_MIN = "Il margine previsto dell'account deve essere almeno 0.";
export const ACCOUNT_MARGIN_MAX = "Il margine previsto dell'account non può superare 100.";
export const PROFILE_UPDATED = "Dettagli del profilo aggiornati con successo.";
export const INVALID_PHONE_NUMBER = "Inserisci un numero di telefono valido (almeno 7 cifre).";
export const PEC_REQUIRED = "È richiesta la PEC.";
export const SDI_REQUIRED = "È richiesta l'SDI.";
export const INVALID_VAT_NUMBER = "Formato IVA non valido.";
export const INVALID_PEC_NUMBER = "Formato PEC non valido.";
export const INVALID_SDI_NUMBER = "Formato SDI non valido.";
export const INVALID_COUNTRY = "Codice paese non valido (deve essere ISO 2).";
export const INVALID_PROVINCE_CODE = 'Codice provincia non valido (es. "MI", "RM").';
export const INVENTORY_UPDATED = "Inventory updated successfully.";
export const ACCOUNT_NOT_VERIFIED = "Your account is not verified. Please check your email for the verification link or request a new one.";
export const RESEND_VERIFICATION_SUCCESS = "Verification email sent. Please check your inbox.";
export const RESEND_VERIFICATION_TITLE = "Enter your email to receive a new verification link.";